import { Dialog, DialogModule } from "@angular/cdk/dialog";
import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";

import { ButtonConfig, Client, Job, VoyseComponent } from "@interfaces";
import { GtagService } from "src/app/containers/gtag/gtag.service";
import { JobDialogComponent } from "src/app/dialogs/job-dialog/job-dialog/job-dialog.component";
import { calculateButtonClasses, calculateButtonStyle } from "src/app/helpers/buttons";
import { SubdomainService } from "src/app/rest/subdomain.service";

@Component({
    selector: "app-job-details-button",
    standalone: true,
    imports: [CommonModule, DialogModule, ],
    templateUrl: "./job-details-button.component.html",
})
export class JobDetailsButtonComponent implements OnInit {
    @Input() component: VoyseComponent;
    @Input() buttonConfig: ButtonConfig;
    @Input() job: Job;
    @Input() buttonSize = "medium";
    public client: Client;
    public buttonStyle = {};
    public buttonClasses = [];

    constructor(
        private subdomain: SubdomainService,
        private dialog: Dialog,
        protected gtag: GtagService
    ) {
        this.subdomain.getClient().subscribe((client: Client) => {
            this.client = client;
        });
    }

    ngOnInit() {
        this.buttonStyle = calculateButtonStyle(this.buttonConfig, this.client);
        this.buttonClasses = calculateButtonClasses(this.buttonConfig);
    }

    public openJobDialog() {
        this.gtag.fireOpenJobDialogEvent(this.job?._id, this.job?.title);
        this.dialog.open(JobDialogComponent, {
            height: "auto",
            maxHeight: "90vh",
            data: { 
                job: this.job,
                component: this.component,
            },
        });
    }
}
